<script>
export default {
  name: 'customer-panel',
  computed: {
    userIsCustomer () {
      return this.$store.getters.getUserType === 'customer';
    }
  },
  methods: {
    getApiEndpoint (baseUrl) {
      if (this.userIsCustomer) {
        baseUrl = '/customer-panel' + baseUrl;
      }

      return baseUrl;
    }
  }
}
</script>
